import React from 'react';
import SideBar from '../../components/modules/left_sidebar';
import NavBar from '../../components/common/navbar';
import DashboardGroup from '../../components/Groups/dashboard_group';

const Administration = false;
class AdminDashboardGroupPage extends React.Component {
  render() {
    const topBarMenu = this.props.location && this.props.location.state && (this.props.location.state.topBarMenu || this.state.topBarMenu);
    return (
      <div className="dashboard">
        <NavBar
          topBarMenuOption={topBarMenu}
          moduleName="Administration"
        />
        <SideBar Administration={Administration} />
        <DashboardGroup />
      </div>
    );
  }
}

export default AdminDashboardGroupPage;
